<template>
  <v-menu
    bottom
    offset-y
    left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon class="mx-n1">
        <v-icon
        medium
        v-bind="attrs"
        color="primary"
        data-testid="tract-detail-actions"
        v-on="on">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list :id="elementId">
      <v-list-item @click="$emit('download-csv')" id="download-csv">
        <v-avatar left>
          <v-icon color="black">mdi-file-delimited-outline</v-icon>
        </v-avatar>
        <v-list-item-title>
          {{$t('downloadCSV')}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="!showRateReview" @click="importTickets(false)" :disabled="!userAssignedClaim(UserClaims.TicketManager)" id="import-tickets">
        <v-avatar left>
          <v-img
          :src="cloudNewPath"
          height="32"
          width="32"
          contain
          />
        </v-avatar>
        <v-list-item-title>
          {{importLabel}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="!showRateReview" @click="importTickets(true)" :disabled="!userAssignedClaim(UserClaims.TicketManager)" id="update-tickets">
        <v-avatar left>
          <v-img
          :src="cloudEditPath"
          height="32"
          width="32"
          contain
          />
        </v-avatar>
        <v-list-item-title>
          {{updateLabel}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showRateSheetTools" @click="$emit('base-rate-finder')" id="open-base-rate-finder">
        <v-avatar left>
          <v-icon size="1.35em" color="black">{{ baseRateMop.path }}</v-icon>
        </v-avatar>
        <v-list-item-title>
          {{$t('baseRateFinder')}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showRateSheetTools" @click="$emit('rate-sheet-divergence')" id="open-rate-sheet-divergence">
        <v-avatar left>
          <v-icon color="black">mdi-note-text</v-icon>
        </v-avatar>
        <v-list-item-title>
          {{$t('activeRateSheets')}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="showRateReview" @click="$emit('rate-review')" id="rate-review">
        <v-avatar left>
          <v-icon color="black">mdi-check-decagram</v-icon>
        </v-avatar>
        <v-list-item-title>
          {{$t('rateReview')}}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { ContractMode, UserClaims } from '@/utils/Enumerations'
import { baseRateMop } from '@/images/AngelSvgLibrary'
export default {
  name: 'ContractContextMenu',

  props: {
    contractMode: {
      type: Object,
      default: () => ({ value: 0 })
    },
    elementId: {
      type: String,
      required: false,
      default: undefined
    },
    showRateReview: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    cloudNewPath: 'img/cloud-new.svg',
    cloudEditPath: 'img/cloud-edit.svg',
    baseRateMop,
    UserClaims
  }),

  computed: {
    ...mapGetters('user', ['companyInfo']),

    showRateSheetTools () {
      return !this.showRateReview && this.contractMode.value !== ContractMode.Byproducts.value && !!this.companyInfo?.scalesTickets
    },

    importLabel () {
      switch (this.contractMode.value) {
        case 0: return this.$t('importLogsTickets')
        case 1: return this.$t('importByproductTickets')
        case 2: return this.$t('importTransferTickets')
        case 3: return this.$t('importLogYardSaleTickets')
      }

      return this.$t('importLogsTickets')
    },

    updateLabel () {
      switch (this.contractMode.value) {
        case 0: return this.$t('updateLogsTickets')
        case 1: return this.$t('updateByproductTickets')
        case 2: return this.$t('updateTransferTickets')
        case 3: return this.$t('updateLogYardSaleTickets')
      }

      return this.$t('importLogsTickets')
    }
  },

  methods: {
    userAssignedClaim,
    importTickets (isUpdate) {
      this.$emit('import-tickets', isUpdate)
    }
  }
}
</script>
